import { WizAPI } from './WizAPI';
import { ComponentHealthDataResponse } from '../types/CicdScan';
import { DiscoveryApi, FetchApi } from '@backstage/core-plugin-api';

export type Options = {
  discoveryApi: DiscoveryApi;
  fetchApi: FetchApi;
};

export class WizClient implements WizAPI {
  private readonly discoveryApi: DiscoveryApi;
  private readonly fetchApi: FetchApi;

  constructor(options: Options) {
    this.discoveryApi = options.discoveryApi;
    this.fetchApi = options.fetchApi;
  }

  async getCicdScans(appName: string): Promise<ComponentHealthDataResponse> {
    const baseUrl = await this.discoveryApi.getBaseUrl('plugin-health-status-backend');

    try {
      const response = await this.fetchApi.fetch(`${baseUrl}/wiz-cicd-scans/${appName}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Failed to fetch CICD scans');
      }

      const payload = await response.json();
      return payload;
    } catch (error: any) {
      throw new Error(`Failed to fetch CICD scans: ${error.message}`);
    }
  }
}
